/* eslint-disable tree-shaking/no-side-effects-in-initialization */
import React, {createContext, useState, useEffect} from 'react'
import {connect} from 'react-redux'
import PropTypes from 'prop-types'
import {withCookies} from 'react-cookie'
import {withApollo} from 'react-apollo'
import ExperimentService from './service'
import {SnowplowContext} from '@cred/react-analytics/SnowplowContextManager'
import {experiment as context} from '@cred/react-analytics/contexts'
import configShape from './config/shape'

const ExperimentContext = createContext({}),
  analyticsContexts = (activeExpriments, config) => Object.keys(activeExpriments).map(experimentId => {
    const {variations, name: experimentName} = config.find(experiment => experiment.id === experimentId),
      variationId = activeExpriments[experimentId],
      {description: variationName} = variations.find(variation => `${variation.id}` === `${variationId}`)

    return context.analytics({
      experimentId,
      experimentName,
      variationId: `${variationId}`,
      variationName
    })
  }),

  ExperimentProvider = ({children, config, client, cookies, url, queryParams, userAgent, isAuthenticated, staticBuild}) => {
    const [manualExperiment, setManualExperiment] = useState([]),
      service = new ExperimentService({
        config,
        client,
        cookies,
        url,
        queryParams,
        userAgent,
        isAuthenticated
      })

    let variationMap = service.activateUrlExperiments()

    if (manualExperiment.length > 0) {
      variationMap = {
        ...variationMap,
        ...service.activateExperimentsById([manualExperiment])
      }
    }

    const activate = id => setManualExperiment(id),
      defaultVariationMap = service.defaultVariationMap

    useEffect(() => {
      service.updateCookiesVariationMap(variationMap)
      service.updatePersistedVariationMap(variationMap)
    }, [JSON.stringify(variationMap)])

    return (
      <ExperimentContext.Provider value={{
        activate,
        variationMap,
        defaultVariationMap,
        staticBuild
      }}>
        <SnowplowContext contexts={analyticsContexts(variationMap, config)}>
          {children}
        </SnowplowContext>
      </ExperimentContext.Provider>
    )
  }

ExperimentProvider.propTypes = {
  cookies: PropTypes.object.isRequired,
  client: PropTypes.object.isRequired,
  config: configShape.isRequired,
  userAgent: PropTypes.string.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  url: PropTypes.string.isRequired,
  queryParams: PropTypes.object,
  staticBuild: PropTypes.bool
}

const mapStateToProps = state => ({
    isAuthenticated: state.auth ? state.auth.status === 'authenticated' : false
  }),
  areEqual = (prevProps, nextProps) => prevProps.url === nextProps.url
    && prevProps.isAuthenticated === nextProps.isAuthenticated

export {ExperimentContext, mapStateToProps, ExperimentProvider as ExperimentProviderNoHOCs}

export default connect(mapStateToProps)(withCookies(withApollo(React.memo(ExperimentProvider, areEqual))))
